import  { useContext, } from "react";
import { FaEdit } from "react-icons/fa";
import { DContext } from "../../context/Datacontext";
import { useNavigate } from "react-router-dom";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { IoPeopleOutline, IoPersonAddOutline } from "react-icons/io5";
// import ClientDetails from "./AdminManagement/ClientDetail";
import { deleteClient, deleteConfirm } from "../services/managerApi/clientsApi";
import { deleteSPOC, SPOCConfirm } from "../services/managerApi/SPOCApis";
import { deleteUser, deleteUserConfrim } from "../services/fetchGetUser";
import { renderImgSrc } from "../../utils/renderImage";
import { deleteStatus } from "../services/managerApi/statusApi";
import { BsPersonFillGear, BsPersonFillLock } from "react-icons/bs";
import { MdEmail } from "react-icons/md";
import { MdCall } from "react-icons/md";
import { FaIdCard } from "react-icons/fa6";
import { RiBuildingFill } from "react-icons/ri";
import { renderCapitalize } from "../../utils/renderCapitalize";
import { StatusType } from "./AdminManagement/StatusType";

export default function AllList({ users, client, spoc, status, setStatusView, setStatusId }) {

    const { BeURL, showDeleteConfirm, showAlert, currentUser } = useContext(DContext)
    const navigate = useNavigate()


    // Capitalize each word in a string
    const formatName = (name) => {
        if (!name) return "";
        return name.trim().split(" ").filter(Boolean) // remove extra spaces
            .map(
                (word) => word.charAt(0)?.toUpperCase() + word.slice(1).toLowerCase()
            ).join(" ");
    };


    // User delete functions
    const handleDeleteUser = async (id) => {
        const confirm = await deleteUserConfrim(BeURL, showDeleteConfirm, showAlert, id)

        if (confirm)
            deleteUser(BeURL, showAlert, id)

    }


    // Client delete handlerClient

    const handleDelete = async (id) => {
        const confirm = await deleteConfirm(BeURL, showDeleteConfirm, showAlert, id)


        if (confirm)
            await deleteClient(BeURL, showAlert, id)

    }

    // SPOC delete handler
    const handleDeleteSPOC = async (id) => {

        const confirm = await SPOCConfirm(BeURL, showDeleteConfirm, showAlert, id)


        if (confirm)
            await deleteSPOC(BeURL, showAlert, id)
    }

    // Status Skills 
    const handleUpdate = (id) => {
        setStatusView(true)
        setStatusId(id)
    }

    const handleDeleteStatus = async (id) => {
        const confirmed = window.confirm("Are you sure you want to delete this status?");

        if (confirmed) {
            await deleteStatus(BeURL, showAlert, id);
        }
    };

    return (
        <div className="p-6">
            {
                users && (
                    <div className="flex flex-col md:flex-row justify-center flex-wrap gap-4 ">
                        {users && users.map((user) => (
                            <div
                                key={user.id}
                                className=" bg-white shadow-lg rounded-2xl px-6 py-3 min-w-80 border border-gray-200"
                            >
                                {/* Profile Pic / Initials */}
                                <div className="flex gap-2 justify-between">
                                    <div className="flex gap-2 items-start">


                                        <img
                                            src={renderImgSrc(user?.profilePicture, user.firstName || user.fullName)}
                                            alt={`${user.firstName} ${user.lastName}`}
                                            className={`shadow ${user.profilePicture ? 'w-16 h-16 rounded-full object-cover'
                                                : 'bg-gradient-to-r from-primary-50 to-secondary-100 text-white text-xl font-bold w-16 h-16 flex items-center justify-center rounded-full '}`}
                                        />

                                        {/* Name */}
                                        <div className="flex flex-col">
                                            <h3 className={`mt-4 text-lg font-semibold ${user.isEmployee === false ? 'text-red-600' : 'text-secondary-400 '} `}>
                                                {formatName(user.fullName)}
                                            </h3>
                                            <p className={`text-sm text-secondary-400  `}>{user?.employementId}</p>
                                        </div>
                                    </div>

                                    {currentUser.role !== 'recruiter' && <div className="flex gap-3">
                                        <button className="  text-primary-300 hover:text-primary-500 transition"
                                            onClick={() => navigate(`/update-users/${user.id}`)}>
                                            <FaEdit size={16} />
                                        </button>


                                        {currentUser.role === 'admin' && (user.role !== 'admin') && <button className="  text-red-600 hover:text-red-800 transition"
                                            onClick={() => handleDeleteUser(user._id)}>
                                            <MdOutlineDeleteOutline size={18} />
                                        </button>}
                                    </div>}

                                </div>
                                <div className=" mx-5 mt-3">
                                    <p className="text-base font-medium flex items-center gap-2"><BsPersonFillGear /> Role : <span className="">{user.role.charAt(0).toUpperCase() + user.role.slice(1)}</span></p>
                                    <p className="text-base font-medium flex items-center gap-2 text-gray-600"><MdEmail /> Email : <span className="font-normal text-gray-600">{user.email}</span></p>
                                    <p className="text-base font-medium flex items-center gap-2 text-gray-600"><MdCall /> Contact : <span className="font-normal text-gray-600">{user.contact}</span></p>
                                    {
                                        user.reportingManager ? <p className="text-base font-medium flex items-center gap-2 text-gray-600"><BsPersonFillLock /> Reporting Manager : <span className="font-normal text-gray-600">{formatName(user.reportingManager.reportingManagerName)}</span></p> : ''
                                    }
                                    {
                                        ["superadmin", "helpdesk"].includes(currentUser.role) &&
                                        <p className="text-base font-medium flex items-center gap-2 text-gray-600"><FaIdCard /> Organization Id: <span className="font-normal text-gray-600">{user.company?.companyId || " - "}</span></p>
                                    }
                                    {
                                        ["superadmin", "helpdesk"].includes(currentUser.role) &&
                                        <p className="text-base font-medium flex items-center gap-2 text-gray-600"><RiBuildingFill /> Organization Name: <span className="font-normal text-gray-600">{user.company?.companyName || " - "}</span></p>
                                    }
                                </div>
                            </div>
                        ))}



                    </div>
                )
            }
            {/* Client Lists */}
            {
                client && (
                    <div className="md:flex md:justify-center">
                        <div className="overflow-x-auto bg-white rounded-xl   shadow-md  md:w-[1070px]">
                            <table className="w-full  text-left border-collapse">
                                <thead className="bg-primary-400 text-white">
                                    <tr>
                                        <th className="p-3 w-[50px]">S.No</th>
                                        <th className="p-3">Logo</th>
                                        <th className="p-3 min-w-[150px]">Client Name</th>
                                        <th className="p-3 min-w-[200px]">Client Link</th>
                                        <th className="p-3 w-[100px]">Industry</th>
                                        <th className="p-3 w-[100px]">Active</th>
                                        <th className="p-3 min-w-[180px] md:table-cell hidden">Created At</th>
                                        <th className="p-3 min-w-[120px]">Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {client.length > 0 ? (
                                        client.map((c, idx) => (
                                            <tr
                                                key={c._id}
                                                className="hover:bg-blue-50 transition border-[0.5px] border-slate-100"
                                            >
                                                <td className="p-3 text-center">{idx + 1}</td>
                                                <td className="p-3">
                                                    {c.logo ? (
                                                        <img
                                                            src={c.logo}
                                                            alt={c.clientName || "Client Logo"}
                                                            className="h-8 w-8 rounded object-contain border"
                                                        />
                                                    ) : (
                                                        <span className="text-xs text-gray-400">-</span>
                                                    )}
                                                </td>
                                                <td className="p-3 text-primary-500 cursor-pointer font-medium"
                                                    onClick={() => navigate(`/clientDetail/${c._id}`)}>{renderCapitalize(c.clientName)}</td>
                                                <td
                                                    className="p-3 font-medium text-primary-500 cursor-pointer "
                                                    onClick={() => window.open(c.clientWebsite, "_blank")}
                                                >
                                                    {c.clientWebsite || '-'}
                                                </td>
                                                <td className="p-3">{c.industry}</td>
                                                <td
                                                    className={`p-3 font-semibold ${c.isActive ? "text-green-600" : "text-red-600"
                                                        }`}
                                                >
                                                    {c.isActive ? "Active" : 'Inactive'}
                                                </td>
                                                <td className="p-3  md:table-cell hidden">
                                                    {new Date(c.created.date).toLocaleString("en-GB")}
                                                </td>
                                                {<td className="p-3 flex gap-3 items-center">
                                                    {(['admin', 'manager', 'teamlead'].includes(currentUser?.role)) && <FaRegEdit className='text-lg text-primary-500 cursor-pointer' title="Update client" onClick={() => navigate(`/update-client/${c._id}`)} />}
                                                    {currentUser?.role === 'admin' && <MdOutlineDeleteOutline className='text-lg text-red-500 cursor-pointer' title="Delete client" onClick={() => handleDelete(c._id)} />}
                                                    {(['admin', 'manager', 'teamlead'].includes(currentUser?.role)) && < IoPersonAddOutline className="text-secondary-400 text-lg cursor-pointer" title="Create SPOC" onClick={() => navigate(`/create-spoc/${c._id}`)} />}
                                                    {(!['superadmin', 'helpdesk'].includes(currentUser?.role)) && < IoPeopleOutline className="text-secondary-400 text-xl cursor-pointer" title="SPOC lists" onClick={() => navigate(`/clientDetail/${c._id}`)} />}
                                                </td>}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="p-3 text-center text-gray-500" colSpan="8">
                                                No Clients found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            {/* SPOC lists */}
            {
                spoc && (
                    <div className="md:flex md:justify-center">
                        <div className="overflow-x-auto bg-white rounded-xl   shadow-md  md:w-[1070px]">
                            <table className="w-full  text-left border-collapse">
                                <thead className="bg-primary-400 text-white">
                                    <tr>
                                        <th className="p-3 w-[50px]">S.No</th>
                                        <th className="p-3">SPOC Name</th>
                                        <th className="p-3">SPOC Email</th>
                                        <th className="p-3">SPOC contact</th>
                                        <th className="p-3 ">Location</th>
                                        <th className="p-3  md:table-cell hidden">Created At</th>
                                        {(currentUser.role === 'admin' || currentUser.role === 'manager' || currentUser.role === 'teamlead') && <th className="p-3">Actions</th>}
                                    </tr>
                                </thead>
                                <tbody>
                                    {spoc.length > 0 ? (
                                        spoc.map((s, idx) => (
                                            <tr
                                                key={s._id}
                                                className="hover:bg-blue-50 transition border-[0.5px] border-slate-100"
                                            >
                                                <td className="p-3 text-center">{idx + 1}</td>
                                                <td className="p-3  " >
                                                    <p className="text-primary-500 font-medium text-lg">{s.fullName}</p>
                                                    <p className="text-base">{s.designation}</p>
                                                </td>
                                                <td
                                                    className="p-3"

                                                >
                                                    {s.email}
                                                </td>
                                                <td className="p-3">{s.contact || '-'}</td>
                                                <td
                                                    className={`p-3`}
                                                >
                                                    {s.clientLocation || '-'
                                                    }
                                                </td>
                                                <td className="p-3  md:table-cell hidden">
                                                    {new Date(s.created.date).toLocaleString("en-GB")}
                                                </td>
                                                {(currentUser.role === 'admin' || currentUser.role === 'manager' || currentUser.role === 'teamlead') && <td className="pt-6 flex items-center flex-start gap-3">
                                                    <FaRegEdit className='text-lg text-primary-500 cursor-pointer' title="Update SPOC" onClick={() => navigate(`/update-spoc/${s._id}`)} />
                                                    {currentUser.role === 'admin' && <MdOutlineDeleteOutline className='text-lg text-red-500 cursor-pointer' title="Delete SPOC" onClick={() => handleDeleteSPOC(s._id)} />}

                                                </td>}
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td className="p-3 text-center text-gray-500" colSpan="7">
                                                No SPOC found.
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )
            }
            {/* Status Lists */}

            {status && (
                    <StatusType status={status} handleUpdate={handleUpdate} handleDeleteStatus={handleDeleteStatus} formatName={formatName} />
                )
            }
        </div>
    );
}
